import { render, staticRenderFns } from "./PredictedStatusInstallationChip.vue?vue&type=template&id=13812e78&"
import script from "./PredictedStatusInstallationChip.vue?vue&type=script&lang=ts&"
export * from "./PredictedStatusInstallationChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VBadge,VChip})
